import React from "react";

import Actions from "./Actions";

const columns = [
  {
    name: "First Name",
    selector: "attributes.first_name",
    sortable: true,
  },
  {
    name: "Last Name",
    selector: "attributes.last_name",
    sortable: true,
  },
  {
    name: "E-Mail",
    selector: "attributes.email",
    sortable: true,
  },

  {
    name: "Action",
    sortable: false,
    width: "100px",
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
